export const TESTIMONIALS_DISPLAYED = 10;

export const SOCIAL_ICON_LG_PX = 13;
export const SOCIAL_ICON_MD_PX = 12;
export const SOCIAL_ICON_SM_PX = 11;

export const FEATURED_TESTIMONIAL_NAMES: string[] = [
  'Sarah Johnson',
  'Jonathan Cooper',
  'Ashley Wilson',
  'Joshua Anderson',
  'Amanda Rodriguez',
  'Tyler Lewis',
  'Cameron Mitchell',
  'Stephanie Garcia',
  'Megan White',
  'Hannah Scott',
];

export const AVATAR_PALETTE: Landing.AvatarColors[] = [
  { bg: '#E0F2FE', color: '#075985' },
  { bg: '#FEF3C7', color: '#92400E' },
  { bg: '#D1FAE5', color: '#065F46' },
  { bg: '#FCE7F3', color: '#9F1239' },
  { bg: '#EDE9FE', color: '#5B21B6' },
  { bg: '#CFFAFE', color: '#155E75' },
];

export const TESTIMONIALS: Landing.Testimonial[] = [
  {
    name: 'Sarah Johnson',
    title: 'House Cleaner',
    location: 'Austin, TX',
    rating: 5,
    quote:
      "My referrals dried up last winter and I've been duct-taping IG DMs and a Google Sheet ever since. Signed up the day a friend showed me the demo.",
  },
  {
    name: 'Michael Chen',
    title: 'Electrician',
    location: 'San Diego, CA',
    rating: 5,
    quote:
      'I write quotes in Notes on my phone and they look like garbage. The Kudable quote builder is exactly what I want clients to see. Claimed my spot.',
  },
  {
    name: 'Jennifer Martinez',
    title: 'Hair Stylist',
    location: 'Miami, FL',
    rating: 5,
    quote:
      "Tired of explaining to strangers in DMs why I'm not a scammer. If the verified review widget does what the landing page says, I'm in.",
  },
  {
    name: 'David Thompson',
    title: 'Plumber',
    location: 'Chicago, IL',
    rating: 5,
    quote:
      "Customers texting me at 9pm asking 'when are you coming?' is brutal. The project status update feature is the only reason I joined.",
  },
  {
    name: 'Amanda Rodriguez',
    title: 'Personal Trainer',
    location: 'Brooklyn, NY',
    rating: 5,
    quote:
      'My Instagram bio link goes to a half-broken Linktree. A real profile with reviews and direct booking is what I should have had years ago.',
  },
  {
    name: 'Christopher Williams',
    title: 'Painter',
    location: 'Denver, CO',
    rating: 5,
    quote:
      "I've tried 3 different apps in the last 2 years and none feel built for one-man shops. Crossing fingers Kudable actually is.",
  },
  {
    name: 'Jessica Brown',
    title: 'Wedding Photographer',
    location: 'Seattle, WA',
    rating: 5,
    quote:
      "I have a Squarespace site I haven't touched in 18 months. If Kudable replaces it for half the price, the day it launches I'm cancelling.",
  },
  {
    name: 'Matthew Davis',
    title: 'Auto Mechanic',
    location: 'Detroit, MI',
    rating: 5,
    quote:
      "Getting customers to leave a review has always been the hardest part. The QR-code-on-the-window idea sold me — sticking one up day one.",
  },
  {
    name: 'Ashley Wilson',
    title: 'Caterer',
    location: 'Atlanta, GA',
    rating: 5,
    quote:
      "Claimed my spot after my third Insta DM this week asking 'are you legit?'. Need verified reviews more than I need sleep.",
  },
  {
    name: 'Joshua Anderson',
    title: 'Custom Carpenter',
    location: 'Charlotte, NC',
    rating: 5,
    quote:
      'I do custom kitchen quotes in Word docs that look like 1998. The quote builder demo is the reason I signed up.',
  },
  {
    name: 'Emily Taylor',
    title: 'Daycare Provider',
    location: 'Phoenix, AZ',
    rating: 5,
    quote:
      "Parents need to trust whoever they leave their kids with. Verified reviews from other parents is exactly what's been missing from my pitch.",
  },
  {
    name: 'Andrew Moore',
    title: 'Landscaper',
    location: 'Portland, OR',
    rating: 5,
    quote:
      'A friend got early access and showed me the bookings + project tracking combo. Every other tool I use is one or the other. Joined that night.',
  },
  {
    name: 'Stephanie Garcia',
    title: 'Bridal Makeup Artist',
    location: 'Las Vegas, NV',
    rating: 5,
    quote:
      "Wedding season I'm juggling Google Sheets, Stripe, and IG DMs. Praying Kudable kills all three so I can actually do the makeup.",
  },
  {
    name: 'Brandon Lee',
    title: 'Wedding DJ',
    location: 'Nashville, TN',
    rating: 5,
    quote:
      'Promoters ghost me on PDF quotes. A signed-in-app quote with reviews behind it would be a completely different conversation.',
  },
  {
    name: 'Megan White',
    title: 'Math Tutor',
    location: 'Boston, MA',
    rating: 5,
    quote:
      'Parents WhatsApp me asking if I actually know the SAT. I want one link that does the convincing for me. Claimed my spot.',
  },
  {
    name: 'Justin Harris',
    title: 'Roofer',
    location: 'Columbus, OH',
    rating: 5,
    quote:
      "Quote turnaround is my biggest bottleneck. If I can quote on-site from my phone and the customer signs right there, I'm in.",
  },
  {
    name: 'Lauren Clark',
    title: 'Graphic Designer',
    location: 'Minneapolis, MN',
    rating: 5,
    quote:
      'Joined for the proposal feature alone. Google Docs back-and-forth with clients has been killing me for years.',
  },
  {
    name: 'Tyler Lewis',
    title: 'Personal Chef',
    location: 'Chicago, IL',
    rating: 5,
    quote:
      "Word of mouth has been my whole business. A platform that makes those reviews public and searchable is the missing piece I've been waiting for.",
  },
  {
    name: 'Brittany Walker',
    title: 'Nail Artist',
    location: 'Orlando, FL',
    rating: 5,
    quote:
      "I'm at the chair all day. If clients can leave a review in 30 seconds from their phone, I'll finally start collecting them.",
  },
  {
    name: 'Ryan Hall',
    title: 'Mover',
    location: 'Houston, TX',
    rating: 5,
    quote:
      "We're a 4-person crew running on SMS, Sheets, and a shared Google Calendar. The team feature is the only reason I signed up.",
  },
  {
    name: 'Samantha King',
    title: 'Wedding Planner',
    location: 'Charleston, SC',
    rating: 5,
    quote:
      'Vendors ignore my emails. A profile with verified weddings on it might finally get them to call me back.',
  },
  {
    name: 'Nicholas Wright',
    title: 'Custom Welder',
    location: 'Pittsburgh, PA',
    rating: 5,
    quote:
      "Niche trade, wasn't sure anything would fit. The portfolio + reviews demo changed my mind — joined the same day.",
  },
  {
    name: 'Hannah Scott',
    title: 'Yoga Instructor',
    location: 'Boulder, CO',
    rating: 5,
    quote:
      'After my studio shut down I rebuilt my client base on spreadsheets and group texts. Kudable looks like the home this business deserves.',
  },
  {
    name: 'Kevin Adams',
    title: 'Pool Cleaner',
    location: 'Tucson, AZ',
    rating: 5,
    quote:
      '200+ pools on my route, all in a spreadsheet I hate. Anything that gives me a real client list with bookings, I am there day one.',
  },
  {
    name: 'Olivia Baker',
    title: 'Event Photographer',
    location: 'New York, NY',
    rating: 5,
    quote:
      'I shoot 80+ events a year and chase review requests manually over text. Automating that alone is worth waiting for.',
  },
  {
    name: 'Ethan Green',
    title: 'Locksmith',
    location: 'Newark, NJ',
    rating: 5,
    quote:
      "Emergency calls only — that's all I get because no one can find a track record on me. Reviews showing up in search would flip that.",
  },
  {
    name: 'Madison Carter',
    title: 'Dog Groomer',
    location: 'Salt Lake City, UT',
    rating: 5,
    quote:
      "Booking flow looks clean in the demo. Anything that lets me stop saying 'check my Insta DMs' to new clients is a win.",
  },
  {
    name: 'Cameron Mitchell',
    title: 'General Contractor',
    location: 'Dallas, TX',
    rating: 5,
    quote:
      'I bid $50k+ projects against guys with no online presence. Verified reviews would be a permanent edge — joined immediately.',
  },
  {
    name: 'Rachel Phillips',
    title: 'Interior Designer',
    location: 'Los Angeles, CA',
    rating: 5,
    quote:
      'My portfolio lives in PDFs I email out. A scrollable, link-shareable version with reviews attached is what I should have had years ago.',
  },
  {
    name: 'Jonathan Cooper',
    title: 'Tile Installer',
    location: 'Tampa, FL',
    rating: 5,
    quote:
      "Every booking platform I've tried takes 20%+. Flat subscription is the only reason I bothered signing up here.",
  },
  {
    name: 'Allison Bell',
    title: 'Pet Sitter',
    location: 'Worcester, MA',
    rating: 5,
    quote:
      'Owners need to feel safe leaving their pet with a stranger. Reviews from neighbors plus pet photos in a portfolio is the exact proof I need.',
  },
  {
    name: 'Trevor Bailey',
    title: 'Handyman',
    location: 'Raleigh, NC',
    rating: 5,
    quote:
      "I lose work to the Craigslist guy because there's no way for me to prove I'm not him. Reviews are how I plan to beat that.",
  },
  {
    name: 'Natalie Reed',
    title: 'Florist',
    location: 'Richmond, VA',
    rating: 5,
    quote:
      'Weddings, events, corporate. The team feature is what got me on the list — my assistant can finally help without us double-booking.',
  },
  {
    name: 'Sean Howard',
    title: 'Window Cleaner',
    location: 'Colorado Springs, CO',
    rating: 5,
    quote:
      "30 homes a week and I'm running it from sticky notes on the dashboard. A real booking calendar is the entire reason I clicked sign up.",
  },
  {
    name: 'Victoria Wood',
    title: 'Esthetician',
    location: 'Houston, TX',
    rating: 5,
    quote:
      'Sending reminders by text takes hours every week. If the WhatsApp client list works the way the demo shows, my Sundays come back.',
  },
  {
    name: 'Patrick Reyes',
    title: 'Mechanic',
    location: 'Springfield, IL',
    rating: 5,
    quote:
      'Honest take on the demo: it looks fine. Going to see how it grows, but the price is right so I claimed my spot.',
  },
  {
    name: 'Courtney Bennett',
    title: 'Lash Artist',
    location: 'Cleveland, OH',
    rating: 5,
    quote:
      'QR-code reviews is the killer feature for me. Client is in the chair, they scan, done — no awkward ask afterwards.',
  },
  {
    name: 'Aaron Foster',
    title: 'IT Consultant',
    location: 'Bellevue, WA',
    rating: 5,
    quote:
      "B2B clients want to see who I've worked with. A clean portfolio with case studies attached is what's been missing from every other platform I've tried.",
  },
  {
    name: 'Kayla Powell',
    title: 'Piano Teacher',
    location: 'Ann Arbor, MI',
    rating: 5,
    quote:
      'Parents share profiles in school group chats all day. A link that has my reviews, schedule, and rates in one place is exactly what I need.',
  },
  {
    name: 'Eric Hughes',
    title: 'HVAC Tech',
    location: 'San Antonio, TX',
    rating: 5,
    quote:
      "Customers shop my quotes around to undercut me. A locked, in-app quote is the only fix I've seen that would actually solve it.",
  },
  {
    name: 'Morgan Coleman',
    title: 'Personal Stylist',
    location: 'Manhattan, NY',
    rating: 5,
    quote:
      "Brand collabs in the roadmap is what got me on the list. Side income from local partnerships is something I've never figured out how to source.",
  },
  {
    name: 'Bryce Jenkins',
    title: 'Tattoo Artist',
    location: 'Memphis, TN',
    rating: 5,
    quote:
      "Portfolio is the whole game in tattooing. A platform where clients book based on a specific piece they like? That's the dream — joined.",
  },
  {
    name: 'Chelsea Perry',
    title: 'House Cleaner',
    location: 'Jacksonville, FL',
    rating: 5,
    quote:
      "WhatsApp client list with one-tap reminders is exactly what I've been duct-taping together for years. Can't sign up fast enough.",
  },
  {
    name: 'Marcus Long',
    title: 'Mover',
    location: 'Savannah, GA',
    rating: 5,
    quote:
      'Crew of 3 spread across 3 different apps and a group chat. Hoping Kudable replaces all of that with one screen.',
  },
  {
    name: 'Sophia Patterson',
    title: 'Personal Trainer',
    location: 'San Francisco, CA',
    rating: 5,
    quote:
      'Reviews and bookings are the two things I actually care about. Most apps bury them under junk features. Kudable leads with both — sold.',
  },
  {
    name: 'Cole Russell',
    title: 'Carpet Cleaner',
    location: 'Reno, NV',
    rating: 5,
    quote:
      "Chain franchises have ad budgets I can't match. A trustworthy review platform is the only way solo guys like me level the playing field.",
  },
  {
    name: 'Bethany Hayes',
    title: 'Corporate Caterer',
    location: 'Plano, TX',
    rating: 5,
    quote:
      "Corporate vendor lists ask for proof. Itemized quotes plus reviews in one link is exactly what they want to see — joined.",
  },
  {
    name: 'Ian Murphy',
    title: 'Pressure Washer',
    location: 'Fort Lauderdale, FL',
    rating: 5,
    quote:
      'Seasonal slumps are brutal. Hoping the social post tool lets me push winter deals to people who saw my work in summer.',
  },
  {
    name: 'Vanessa Stewart',
    title: 'Massage Therapist',
    location: 'Scottsdale, AZ',
    rating: 5,
    quote:
      'Solo practice, no front desk. If Kudable handles bookings, intake, and reviews so I can just show up and do the work — yes, please.',
  },
  {
    name: 'Connor Edwards',
    title: 'Lawn Care',
    location: 'Greensboro, NC',
    rating: 5,
    quote:
      "Just started this year. Claimed my profile hoping it helps me get past the 'how do I even get found' phase.",
  },
];

export const TOP_PERSONAS_SHOWN = 8;

